import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { getPassengerTypeLabel } from '../../../../utils';
import { Tooltip } from '../../../../BaseComponents';
import Money from '../../../../Money';
const TaxesTooltip = ({ className, children, passengerFares, totalPrice }) => {
    const { t } = useTranslation('DesktopFlightInfo');
    const { FlightPriceStyles: theme } = useTheme('DesktopFlightRoute');
    const farePrices = new Map();
    passengerFares.forEach(fare => {
        var _a, _b;
        if (fare === null || fare === void 0 ? void 0 : fare.passengerType) {
            const baseFare = Object.assign(Object.assign({}, fare.baseFare), { amount: ((_a = fare.baseFare) === null || _a === void 0 ? void 0 : _a.amount) * fare.count });
            const totalTaxes = Object.assign(Object.assign({}, fare.totalTaxes), { amount: ((_b = fare.totalTaxes) === null || _b === void 0 ? void 0 : _b.amount) * fare.count });
            farePrices.set(fare.passengerType, Object.assign(Object.assign({}, fare), { baseFare, totalTaxes }));
        }
    });
    const content = farePrices.size > 0 && (React.createElement("div", { className: theme.price__details },
        [...farePrices.values()].map((passengerFare, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement("div", { className: theme.price__group },
                React.createElement("div", { className: theme.price__label },
                    passengerFare.count,
                    ' ',
                    getPassengerTypeLabel(passengerFare.passengerType, undefined, passengerFare.count)),
                React.createElement("div", { className: theme.price__item },
                    React.createElement("span", null, t('Tariff')),
                    " ",
                    React.createElement(Money, { money: passengerFare.baseFare })),
                React.createElement("div", { className: theme.price__item },
                    React.createElement("span", null, t('Taxes')),
                    " ",
                    React.createElement(Money, { money: passengerFare.totalTaxes }))),
            React.createElement("div", { className: theme.price__separator })))),
        React.createElement("div", { className: cn(theme.price__item, theme.price__item_total) },
            React.createElement("span", null, t('Total')),
            " ",
            React.createElement(Money, { money: totalPrice }))));
    if (!content) {
        return null;
    }
    return (React.createElement("span", { className: theme.taxes },
        React.createElement(Tooltip, { className: className, title: content, placement: "bottom-end", enterTouchDelay: 0, PopperProps: {
                modifiers: [
                    { name: 'flip', enabled: true },
                    { name: 'preventOverflow', enabled: true }
                ]
            } }, children)));
};
export default TaxesTooltip;
